import React, { useRef } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";

import github from "../../assets/icons/github.png";
import insta from "../../assets/icons/insta.png";
import linkedin from "../../assets/icons/linkedin.png";
import mail from "../../assets/icons/mail.png";

const Contact = () => {

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_zgvcfy6",
        "template_hyqn0ih",
        form.current,
        "NTrru4fRYGsOkk3pc"
      )
      .then(
        (result) => {
          console.log(result.text);
          e.target.reset();
          alert("Email sent");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <section className="contactPage">
      <div id="contact">
        <h1 className="contactPageTitle">Contact Me</h1>
        <span className="contactDesc"></span>
        <form className="contact" ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="user_name"
            className="name input_section"
            placeholder="Your Name"
          />
          <input
            type="text"
            name="user_email"
            className="email input_section"
            placeholder="Email"
          />
          <textarea
            type="text"
            rows="5"
            cols="40"
            name="message"
            className="message input_section"
            placeholder="Message"
          />
          <button type="submit" value="Send" className="submitBtn">
            Submit
          </button>
        </form>
        <div className="links">
          <a href="https://github.com/kayamekin" target="_blank">
            <img src={github} alt="" className="link" />
          </a>
          <a href="https://instagram.com/mekinbaturalp" target="_blank">
            <img src={insta} alt="" className="link" />
          </a>
          <a href="https://www.linkedin.com/in/kaya-mekin-baturalp-a477a5274/" target="_blank">
            <img src={linkedin} alt="" className="link" target="_blank"/>
          </a>
          <a href="mailto: baturalpmekin@gmail.com" target="_blank">
            <img src={mail} alt="" className="link" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
